export const establishmentStatus = {
  0: "Ativo",
  1: "Inativo",
  2: "Inadimplente",
};

export const discountType = {
  0: "Desconto em Valor",
  1: "Desconto em Porcentagem",
};

export const showIn = {
  0: "Ambos apps (Lav Control e Máquina de Pagamento)",
  1: "Somente no app Lav Control",
  2: "Somente na Máquina de Pagamento",
};

export const dayOfWeek = {
  0: "Segunda-feira",
  1: "Terça-feira",
  2: "Quarta-feira",
  3: "Quinta-feira",
  4: "Sexta-feira",
  5: "Sábado",
  6: "Domingo",
};

export const machineType = {
  0: "Lavadora Comum",
  1: "Secadora Comum",
  2: "Lavadora Industrial",
  3: "Secadora Industrial",
};

export const machineStatus = {
  0: "Ocupada",
  1: "Disponível",
  2: "Em Manutenção",
  3: "Reservada",
  4: "Deletada",
};

export const USER_ROLES = Object.freeze({
  USER: 1, // Usuário
  SUPORTER: 2, // Suporte
  SUPERUSER: 3, // Superuser (Django Admin)
  LAUNDRY_ADMIN: 4, // Admin. Estabelecimento
  CONDO_ADMIN: 5, // Admin. Condomínio
  LAVCON_ADMIN: 6, // Super Administrador
  SYNDICATE: 7, // Sindicatura
  SERVICE: 8, // Serviço (Esp, Cron Jobs)
  LOCATOR: 9, // Locador
  INTERMEDIARY: 10, // Intermediador
});

export const transactionStatus = {
  UNKNOWN: "Ocorreu um erro antes de ser enviada para o autorizador (UNKNOWN)",
  APPROVED: "Transação aprovada com sucesso (APPROVED)",
  DECLINED: "Transação negada (DECLINED)",
  DECLINED_BY_CARD: "Transação negada pelo cartão (DECLINED_BY_CARD)",
  CANCELLED: "Transação cancelada (CANCELLED)",
  PARTIAL_APPROVED: "Transação foi parcialmente aprovada (PARTIAL_APPROVED)",
  TECHNICAL_ERROR:
    "Erro técnico ao processar a mensagem no autorizador (TECHNICAL_ERROR)",
  REJECTED: "Transação rejeitada (REJECTED)",
  WITH_ERROR:
    "Transação não completada com sucesso, será revertida (WITH_ERROR)",
  PENDING: "O provider de transação está em andamento (PENDING)",
  REVERSED:
    "Transação cancelada automaticamente devido a erro ou interrupção (REVERSED)",
  PENDING_REVERSAL:
    "Transação foi interrompida por algum motivo e será revertida pelo provider de reversão (PENDING_REVERSAL)",
};

export const actionCodes = {
  1000: "Não aprovado (1000)",
  1001: "Cartão vencido (1001)",
  1002: "Suspeita de fraude (1002)",
  1003: "Estabelecimento entrar em contato com adquirente (1003)",
  1004: "Cartão com restrição (1004)",
  1005: "Estabelecimento entrar em contato com departamento de segurança do adquirente (1005)",
  1006: "Tentativas de senha excedidas (1006)",
  1007: "Consultar o emissor (1007)",
  1008: "Consultar as condições especiais do emissor (1008)",
  1009: "Estabelecimento inválido (1009)",
  1010: "Valor inválido (1010)",
  1011: "Cartão inválido (1011)",
  1012: "Senha necessária (1012)",
  1014: "Nenhuma conta do tipo selecionado (1014)",
  1015: "Função selecionada não suportada (1015)",
  1016: "Saldo insuficiente (1016)",
  1017: "Senha inválida (1017)",
  1019: "Transação não permitida para o portador (1019)",
  1020: "Transação não permitida para o terminal (1020)",
  1021: "Limite de valor para saque excedido (1021)",
  1022: "Violação de segurança (1022)",
  1023: "Limite de quantidade de saques excedido (1023)",
  1024: "Violação da lei (1024)",
  1025: "Cartão bloqueado (1025)",
  1026: "Dados de senha inválidos (1026)",
  1027: "Erro no tamanho da senha (1027)",
  1028: "Erro de sincronia de chave de senha (1028)",
  1029: "Suspeita de cartão falso (1029)",
  1030: "Moeda inaceitável para o emissor (1030)",
  1032: "Cartão perdido ou roubado (1032)",
  1035: "Conta encerrada (1035)",
  1036: "Conta poupança encerrada ou bloqueada para encerramento (1036)",
  1037: "Conta de crédito encerrada ou bloqueada para encerramento (1037)",
  1039: "Conta corrente encerrada ou bloquada para encerramento (1039)",
  1041: "Status ruim para conta de origem (1041)",
  1042: "Status ruim para conta de destino (1042)",
  1045: "Código de segurança inválido (1045)",
  1047: "Troca de senha necessária (1047)",
  1048: "Nova senha inválida (1048)",
  1057: "Data de pagamento inválida (1057)",
  1060: "Transação não completou normalmente no terminal (1060)",
  1061: "Transação não suportada pelo emissor (1061)",
  1062: "Saque fácil não disponível (1062)",
  1063: "Limite de saque fácil excedido (1063)",
  1064: "Negado offline pelo terminal (1064)",
  1065: "Negado, não foi possível processar offline (1065)",
  2000: "Não aprovado (2000)",
  2001: "Cartão vencido (2001)",
  2002: "Suspeita de fraude (2002)",
  2003: "Estabelecimento entrar em contato com emissor (2003)",
  2004: "Cartão com restrição (2004)",
  2005: "Estabelecimento entrar em contato com departamento de segurança do adquirente (2005)",
  2006: "Tentativas de senha excedidas (2006)",
  2007: "Condições especiais (2007)",
  2008: "Cartão perdido (2008)",
  2009: "Cartão roubado (2009)",
  2010: "Suspeita de cartão falso (2010)",
  2011: "Limite de quantidade de saques excedido (2011)",
  2012: "Limite de valor para saque excedido (2012)",
  9100: "Erro no formato da mensagem (9100)",
  9102: "Transação inválida (9102)",
  9103: "Tente novamente (9103)",
  9105: "Adquirente não suportado pelo switch (9105)",
  9107: "Emissor fora de operação (9107)",
  9108: "Não foi possível enviar a transação para o destinatário (9108)",
  9109: "Erro no sistema (9109)",
  9110: "Emissor se desconectou (9110)",
  9111: "Emissor não respondeu em tempo (9111)",
  9112: "Emissor indisponível (9112)",
  9113: "Transmissão duplicada (9113)",
  9114: "Não foi possível encontrar a transação original (9114)",
  9116: "MAC incorreto (9116)",
  9117: "Erro de sincronização de chave de MAC (9117)",
  9118: "Nenhuma chave de comunicação disponível (9118)",
  9119: "Erro de sincronização de chave de encriptação (9119)",
  9120: "Erro de segurança de software/hardware, tente novamente (9120)",
  9121: "Erro de segurança de software/hardware (9121)",
  9122: "Número da mensagem fora de sequência (9122)",
  9123: "Requisição em progresso (9123)",
  9124: "Código de segurança inválido (9124)",
  9125: "Erro no banco de dados (9125)",
  9132: "Erro nos dados de recorrência (9132)",
  9133: "Atualização não permitida (9133)",
  9350: "Violação de acordo comercial (9350)",
  9999: "Erro não especificado (9999)",
  UNPR: "Não foi possível processar a mensagem. Tente novamente (UNPR)",
  IMSG: "A mensagem enviada possui um formato inválido (IMSG)",
  PARS: "Algum campo obrigatório não esta sendo enviado (PARS)",
  SECU: "Algum erro no processo de segurança. A chave de criptografia pode não estar presente no terminal (SECU)",
  INTP: "O SAK enviado não foi reconhecido (INTP)",
  RCPP: "O local para aonde a mensagem foi enviada esta invalida (RCPP)",
  DPMG: "Esta mensagem já foi recebida pela Stone (DPMG)",
  VERS: "A versão do protocolo enviada não é suportada (VERS)",
  MSGT: "O Message Type enviado não é reconhecido (MSGT)",
};

export const errorsEnum = {
  CARD_BLOCKED: "Cartão bloqueado (CARD_BLOCKED)",
  CARD_REMOVED_BY_USER: "Cartão removido (CARD_REMOVED_BY_USER)",
  CANT_READ_CARD_HOLDER_INFORMATION: "Não foi possível ler os dados do titular (CANT_READ_CARD_HOLDER_INFORMATION)",
  INVALID_TRANSACTION: "Transação inválida (INVALID_TRANSACTION)",
  PASS_TARGE_WITH_CHIP: "Cartão com chip (PASS_TARGE_WITH_CHIP)",
  INVALID_TRANSACTION_STATUS: "Status de transação inválido (INVALID_TRANSACTION_STATUS)",
  CANT_READ_CHIP_CARD: "Erro na leitura do chip (CANT_READ_CHIP_CARD)",
  SWIPE_INCORRECT: "Leitura incorreta (SWIPE_INCORRECT)",
  TOO_MANY_CARDS: "Mais de um cartão detectado (TOO_MANY_CARDS)",
  CARD_READ_ERROR: "Erro de leitura do cartão (CARD_READ_ERROR)",
  CARD_READ_TIMEOUT_ERROR: "Tempo limite para leitura (CARD_READ_TIMEOUT_ERROR)",
  CARD_READ_CANCELED_ERROR: "Leitura cancelada (CARD_READ_CANCELED_ERROR)",
  CARD_UNSUPPORTED_ERROR: "Cartão não suportado (CARD_UNSUPPORTED_ERROR)",
  INVALID_AMOUNT: "Valor inválido (INVALID_AMOUNT)",
  TRANS_CVV_NOT_PROVIDED_ERROR: "CVV não informado (TRANS_CVV_NOT_PROVIDED_ERROR)",
  TRANS_CVV_INVALID_ERROR: "CVV inválido (TRANS_CVV_INVALID_ERROR)",
  TRANSACTION_NOT_FOUND: "Transação não encontrada (TRANSACTION_NOT_FOUND)",
  CARD_READ_MULTI_ERROR: "Mais de um cartão detectado (CARD_READ_MULTI_ERROR)",
  TRANSACTION_FALLBACK_STARTED: "Transação de chip falhou (TRANSACTION_FALLBACK_STARTED)",
  TRANSACTION_FALLBACK_TIMEOUT: "Tempo limite de fallback (TRANSACTION_FALLBACK_TIMEOUT)",
  TRANSACTION_FALLBACK_INVALID_CARD_MODE: "Modo de cartão inválido (TRANSACTION_FALLBACK_INVALID_CARD_MODE)",
  NO_ACTIVE_APPLICATION: "Sem aplicativo ativo (NO_ACTIVE_APPLICATION)",
  TRANSACTION_OBJECT_NULL_ERROR: "Objeto da transação nulo (TRANSACTION_OBJECT_NULL_ERROR)",
  TRANS_GENERIC_ERROR: "Erro na transação (TRANS_GENERIC_ERROR)",
  TRANS_APP_BLOCKED_ERROR: "Aplicativo bloqueado (TRANS_APP_BLOCKED_ERROR)",
  TRANS_SELECT_TYPE_USER_CANCELED_ERROR: "Seleção de tipo cancelada (TRANS_SELECT_TYPE_USER_CANCELED_ERROR)",
  TRANS_INVALID_AMOUNT_ERROR: "Valor inválido (TRANS_INVALID_AMOUNT_ERROR)",
  TRANS_PASS_MAG_BUT_IS_ICC_ERROR: "Pass não suportado (TRANS_PASS_MAG_BUT_IS_ICC_ERROR)",
  TRANS_NO_TRANS_TYPE_ERROR: "Sem tipo de transação (TRANS_NO_TRANS_TYPE_ERROR)",
  TRANS_WRONG_TRANS_TYPE_ERROR: "Tipo de transação incorreto (TRANS_WRONG_TRANS_TYPE_ERROR)",
  TRANS_APP_INVALID_ERROR: "Aplicativo inválido (TRANS_APP_INVALID_ERROR)",
  TRANS_APP_INVALID_INDEX_ERROR: "Índice de aplicativo inválido (TRANS_APP_INVALID_INDEX_ERROR)",
  TRANS_ONLINE_PROCESS_ERROR_ERROR: "Erro no processamento online (TRANS_ONLINE_PROCESS_ERROR_ERROR)",
  CONNECTION_NOT_FOUND: "Conexão não encontrada (CONNECTION_NOT_FOUND)",
  IO_ERROR_WITH_PINPAD: "Erro de entrada/saída com o leitor (IO_ERROR_WITH_PINPAD)",
  PINPAD_CONNECTION_NOT_FOUND: "Leitor não encontrado (PINPAD_CONNECTION_NOT_FOUND)",
  TIME_OUT: "Tempo limite esgotado (TIME_OUT)",
  CONNECTIVITY_ERROR: "Erro de conectividade (CONNECTIVITY_ERROR)",
  PINPAD_WITHOUT_KEY: "Leitor não ativado (PINPAD_WITHOUT_KEY)",
  PINPAD_WITHOUT_STONE_KEY: "Sem chave Stone (PINPAD_WITHOUT_STONE_KEY)",
  PINPAD_ALREADY_CONNECTED: "Leitor já conectado (PINPAD_ALREADY_CONNECTED)",
  PINPAD_CLOSED_CONNECTION: "Conexão com o leitor fechada (PINPAD_CLOSED_CONNECTION)",
  NOT_STONE_POS_OR_POS_MISCONFIGURED: "Leitor não reconhecido (NOT_STONE_POS_OR_POS_MISCONFIGURED)",
  COULD_NOT_ACTIVATE_ALL_STONE_CODES: "Falha na ativação (COULD_NOT_ACTIVATE_ALL_STONE_CODES)",
  COULD_NOT_ACTIVATE_WITH_ACCEPTOR_CONFIGURATION_UPDATE_DATA_NULL: "Falha na configuração (COULD_NOT_ACTIVATE_WITH_ACCEPTOR_CONFIGURATION_UPDATE_DATA_NULL)",
  NO_MIFARE_SUPPORT: "Sem suporte a Mifare (NO_MIFARE_SUPPORT)",
  MIFARE_ABORTED: "Operação Mifare abortada (MIFARE_ABORTED)",
  MIFARE_DETECT_TIMEOUT: "Tempo limite Mifare (MIFARE_DETECT_TIMEOUT)",
  MIFARE_WRONG_CARD_TYPE: "Tipo de cartão Mifare incorreto (MIFARE_WRONG_CARD_TYPE)",
  MIFARE_INVALID_KEY: "Chave Mifare inválida (MIFARE_INVALID_KEY)",
  MIFARE_NOT_AUTHENTICATED: "Mifare não autenticado (MIFARE_NOT_AUTHENTICATED)",
  MIFARE_INVALID_SECTOR_NUMBER: "Setor Mifare inválido (MIFARE_INVALID_SECTOR_NUMBER)",
  MIFARE_INVALID_BLOCK_NUMBER: "Bloco Mifare inválido (MIFARE_INVALID_BLOCK_NUMBER)",
  MIFARE_INVALID_BLOCK_FORMAT: "Formato de bloco inválido (MIFARE_INVALID_BLOCK_FORMAT)",
  MIFARE_MULTI_CARD_DETECTED: "Detectado mais de um cartão (MIFARE_MULTI_CARD_DETECTED)",
  DATA_CONTAINER_CONSTRAINT_ERROR: "Erro de dados (DATA_CONTAINER_CONSTRAINT_ERROR)",
  DATA_CONTAINER_INTEGRATION_ERROR: "Erro de integração de dados (DATA_CONTAINER_INTEGRATION_ERROR)",
  UNEXPECTED_STATUS_COMMAND: "Erro inesperado (UNEXPECTED_STATUS_COMMAND)",
  UNKNOWN_ERROR: "Ocorreu um erro (UNKNOWN_ERROR)",
  INTERNAL_ERROR: "Erro interno (INTERNAL_ERROR)",
  NULL_RESPONSE: "Resposta nula (NULL_RESPONSE)",
  ERROR_RESPONSE_COMMAND: "Resposta inválida (ERROR_RESPONSE_COMMAND)",
  INVALID_STONE_CODE_OR_UNKNOWN: "Código Stone inválido (INVALID_STONE_CODE_OR_UNKNOWN)",
  INVALID_STONECODE: "Código Stone inválido (INVALID_STONECODE)",
  USERMODEL_NOT_FOUND: "Dados de usuário não encontrados (USERMODEL_NOT_FOUND)",
  MULTI_INSTANCES_OF_PROVIDER_RUNNING: "Várias instâncias ativas (MULTI_INSTANCES_OF_PROVIDER_RUNNING)",
  UNKNOWN_TYPE_OF_USER: "Tipo de usuário desconhecido (UNKNOWN_TYPE_OF_USER)",
  APPNAME_NOT_SET: "Nome do app não configurado (APPNAME_NOT_SET)",
  SDK_VERSION_OUTDATED: "SDK desatualizado (SDK_VERSION_OUTDATED)",
  NO_PRINT_SUPPORT: "Impressão não suportada (NO_PRINT_SUPPORT)",
  PRINTER_GENERIC_ERROR: "Erro da impressora (PRINTER_GENERIC_ERROR)",
  PRINTER_BUSY_ERROR: "Impressora ocupada (PRINTER_BUSY_ERROR)",
  PRINTER_INIT_ERROR: "Erro de inicialização da impressora (PRINTER_INIT_ERROR)",
  PRINTER_LOW_ENERGY_ERROR: "Bateria da impressora fraca (PRINTER_LOW_ENERGY_ERROR)",
  PRINTER_OUT_OF_PAPER_ERROR: "Sem papel (PRINTER_OUT_OF_PAPER_ERROR)",
  PRINTER_UNSUPPORTED_FORMAT_ERROR: "Formato de impressão não suportado (PRINTER_UNSUPPORTED_FORMAT_ERROR)",
  PRINTER_INVALID_DATA_ERROR: "Dados de impressão inválidos (PRINTER_INVALID_DATA_ERROR)",
  PRINTER_OVERHEATING_ERROR: "Impressora superaquecendo (PRINTER_OVERHEATING_ERROR)",
  PED_PASS_GENERIC_ERROR: "Erro no PIN Pad (PED_PASS_GENERIC_ERROR)",
  PED_PASS_KEY_ERROR: "Erro na chave do PIN Pad (PED_PASS_KEY_ERROR)",
  PED_PASS_USER_CANCELED_ERROR: "Operação cancelada (PED_PASS_USER_CANCELED_ERROR)",
  PED_PASS_NO_PIN_INPUT_ERROR: "Nenhum PIN digitado (PED_PASS_NO_PIN_INPUT_ERROR)",
  PED_PASS_TIMEOUT_ERROR: "Tempo limite do PIN Pad (PED_PASS_TIMEOUT_ERROR)",
  PED_PASS_INIT_ERROR: "Erro de inicialização do PIN Pad (PED_PASS_INIT_ERROR)",
  PED_PASS_CRYPT_ERROR: "Erro de criptografia (PED_PASS_CRYPT_ERROR)",
  PED_PASS_NO_KEY_FOUND_ERROR: "Chave não encontrada (PED_PASS_NO_KEY_FOUND_ERROR)",
  OPERATION_CANCELLED_BY_USER: "Operação cancelada (OPERATION_CANCELLED_BY_USER)",
  ACCEPTOR_REJECTION: "Transação rejeitada (ACCEPTOR_REJECTION)",
  EMAIL_MESSAGE_ERROR: "Erro no e-mail (EMAIL_MESSAGE_ERROR)",
  INVALID_EMAIL_CLIENT: "Cliente de e-mail inválido (INVALID_EMAIL_CLIENT)",
  EMAIL_EMPTY: "E-mail vazio (EMAIL_EMPTY)",
  EMAIL_RECIPIENT_EMPTY: "Destinatário vazio (EMAIL_RECIPIENT_EMPTY)",
  QRCODE_NOT_GENERATED: "QR Code não gerado (QRCODE_NOT_GENERATED)",
  QRCODE_EXPIRED: "QR Code expirou (QRCODE_EXPIRED)",
  EMV_GENERIC_ERROR: "Erro do chip (EMV_GENERIC_ERROR)",
  EMV_FAILED_CARD_CONN_ERROR: "Falha na conexão com o chip (EMV_FAILED_CARD_CONN_ERROR)",
  EMV_NO_APP_ERROR: "Sem aplicativo no chip (EMV_NO_APP_ERROR)",
  EMV_INITIALIZATION_ERROR: "Erro de inicialização do chip (EMV_INITIALIZATION_ERROR)",
  EMV_CAPK_ERROR: "Erro na chave do certificado (EMV_CAPK_ERROR)",
  EMV_TLV_ERROR: "Erro de dados TLV (EMV_TLV_ERROR)",
  EMV_NO_CAPK_ERROR: "Chave de certificado não encontrada (EMV_NO_CAPK_ERROR)",
  EMV_AID_ERROR: "Erro no aplicativo do chip (EMV_AID_ERROR)",
  DEVICE_NOT_COMPATIBLE: "Dispositivo não compatível (DEVICE_NOT_COMPATIBLE)",
  GENERIC_ERROR: "Erro genérico (GENERIC_ERROR)",
  TABLES_NOT_FOUND: "Tabelas não encontradas (TABLES_NOT_FOUND)",
  NEED_LOAD_TABLES: "Carregue as tabelas (NEED_LOAD_TABLES)",
  SWITCH_INTERFACE: "Troque a interface (SWITCH_INTERFACE)",
  CARD_GENERIC_ERROR: "Erro genérico (CARD_GENERIC_ERROR)",
};
